export const baseUrl = "https://evp-inspiring-chats.firebaseapp.com"
export const googlePlacesAPIKey = "AIzaSyCT5TENLgN6AoB8v0vpm-iSl8HTSobjhfA"
export const linkedinClientId = "78684ogzhpbj4j"

export const oauthEndpoints = {
  google: {
    authorizeUrl: "https://accounts.google.com/o/oauth2/v2/auth",
    tokenUrl: "https://accounts.google.com/o/oauth2/token",
    clientId: "975415586210-pg4fkr2crcpnm48elk87larg84pg6c26.apps.googleusercontent.com",
  },
  microsoft: {
    authorizeUrl: "https://login.microsoftonline.com/common/oauth2/v2.0/authorize",
    tokenUrl: "https://login.microsoftonline.com/common/oauth2/v2.0/token",
    clientId: "2d2c25f3-a387-45e6-8229-42f64bb8fdab",
  },
}
